export enum LogoSize {
  Small = "s",
  Medium = "m",
  Big = "b",
  Original = "o"
}
